import { createFileRoute } from "@tanstack/react-router";
import { AccountSettings } from "@client/components/settings/account-settings";

export const Route = createFileRoute("/_app/account")({
  component: AccountSettings,
});
